import { render } from "./Davor.vue?vue&type=template&id=784b7996&scoped=true"
import script from "./Davor.vue?vue&type=script&lang=js"
export * from "./Davor.vue?vue&type=script&lang=js"

import "./Davor.vue?vue&type=style&index=0&id=784b7996&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\souvielink\\souvielink\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784b7996"]])

export default __exports__